'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = require("./index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var AdapterText = function AdapterText(props) {
  return /*#__PURE__*/_react.default.createElement(_index.TextInput, _extends({}, props, {
    readOnly: props.disabled
  }));
};

AdapterText.propTypes = _index.TextInput.propTypes;
AdapterText.propTypes.disabled = _propTypes.default.bool;
var _default = AdapterText;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/form-inputs/adapter-text.js
// module id = 543
// module chunks = 0